module.exports = __webpack_public_path__ + "static/media/autopilot-01.48cd6647.png";